import { render, staticRenderFns } from "./VisitorModal.vue?vue&type=template&id=ca83a566&"
import script from "./VisitorModal.vue?vue&type=script&lang=js&"
export * from "./VisitorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca83a566')) {
      api.createRecord('ca83a566', component.options)
    } else {
      api.reload('ca83a566', component.options)
    }
    module.hot.accept("./VisitorModal.vue?vue&type=template&id=ca83a566&", function () {
      api.rerender('ca83a566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/modules/VisitorModal.vue"
export default component.exports